<template>
	<div class="status-message" :class="{ active: isActive }">
		<p>{{ message }}</p>
	</div>
</template>


<script>
	export default {
		name: 'status-message',
		data() {
			return {
				isActive: false,
				currentMessage: ''
			}
		},
		computed: {
			message() {
				return this.$store.getters.statusMessage
			}
		},
		mounted() {
			if (window.location.hash === '#unauthorized') {
				window.location.hash = '';
				this.$store.commit('setStatusMessage', 'You must be in the Paradise Motel Discord server to log in.')
			}
		},
		watch: {
			message() {
				if (this.message) {
					if (this.currentTimeout) {
						clearTimeout(this.currentTimeout)
					}

					this.isActive = true;
					this.currentMessage = this.message

					this.currentTimeout = setTimeout(() => {
						this.isActive = false

						setTimeout(() => {
							this.currentMessage = ''
							this.$store.commit('setStatusMessage', '')
						}, 500)

					}, 5200)
				}
			}
		}
	}
</script>


<style lang="scss">
	
	.status-message {
		position: fixed;
		top: 6px;
		right: 6px;
		background: #fff;
		opacity: 0;
		box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
		pointer-events: none;
		transform: translateY(-20px);
		transition: opacity 0.5s, transform 0.5s;

		&.active {
			opacity: 1.0;
			transform: translateY(0);
		}

		p {
			margin: 0;
			padding: 2px 10px;
		}
	}

</style>
